import navToListing from '../helpers/navToListing';
import { useSearch } from '../contexts/SearchContext';
import useLazyFetchSearchGeneralByPhrase from '@th/frontend-shared/src/hooks/queries/useLazyFetchSearchGeneralByPhrase';
import useNavToPlace from './useNavToPlace';
import { useMap } from '../contexts/MapContext';

export default function useFetchSearchGeneralAndNavToResult(): [
  (phrase: string) => void,
  { isLoading: boolean },
] {
  const {
    resetAndUpdateFiltersOnTopOfExistingCoreValues,
    openNlpSearchStatusModalToLoading,
    closeNlpSearchModal,
  } = useSearch();
  const [fetchSearchGeneralByPhrase, { isLoading }] =
    useLazyFetchSearchGeneralByPhrase();
  const navToPlace = useNavToPlace();
  const { clearAreaOverlay } = useMap();

  async function fetchSearchGeneralAndNavToResult(searchPhrase: string) {
    openNlpSearchStatusModalToLoading(searchPhrase);
    // We don't know what type of search this is yet, fire a general (any) search
    const result = await fetchSearchGeneralByPhrase(searchPhrase);
    closeNlpSearchModal();
    if (result.place) {
      navToPlace(result.place);
    } else if (result.listing) {
      navToListing(result.listing);
    } else if (result.searchFilters) {
      const searchFilters = result.searchFilters;
      clearAreaOverlay();
      resetAndUpdateFiltersOnTopOfExistingCoreValues(searchFilters);
      closeNlpSearchModal();
    }
  }

  return [fetchSearchGeneralAndNavToResult, { isLoading }];
}
